import type { DmInboxStatus, DmNotificationSort } from '../../../services/dmNotifications';
import {
    buildListFilterSummary,
    sortText,
    tagsLine,
    type ListFilterLine,
    type ListFilterSummary,
    type SharedFilterSources,
    type SortPhrase
} from '../shared/listFilterSummary.ts';
import type { ListSortOrder } from '../shared/listUrlState';
import { levelFilterLabels } from './dmNotificationLevels.ts';

// As inboxOrderBy orders: alert ranks highest; latest and waiting use the newest and oldest open one.
export const NOTIFICATION_SORT_PHRASES: Readonly<Record<DmNotificationSort, SortPhrase>> = {
    level: { column: 'level', desc: 'most urgent first', asc: 'least urgent first' },
    waiting: { column: 'waiting', asc: 'longest waiting first', desc: 'shortest waiting first' },
    latest: { column: 'latest', desc: 'newest first', asc: 'oldest first' }
};

export function notificationSortText(sort: DmNotificationSort, order: ListSortOrder): string {
    return sortText(NOTIFICATION_SORT_PHRASES[sort], order);
}

export function levelLine(levels: readonly string[]): ListFilterLine[] {
    const labels = levelFilterLabels(levels);
    return labels.length === 0 ? [] : [{ key: 'level', label: 'Level', value: labels.join(', ') }];
}

export interface NotificationSummarySource {
    shared: SharedFilterSources;
    levels: readonly string[];
    tags: readonly string[];
    status: DmInboxStatus;
    sort: DmNotificationSort;
    order: ListSortOrder;
    total: number | null;
}

export function notificationListSummary({
    shared,
    levels,
    tags,
    status,
    sort,
    order,
    total
}: NotificationSummarySource): ListFilterSummary {
    return buildListFilterSummary(
        shared,
        [...levelLine(levels), ...tagsLine(tags)],
        total,
        status,
        notificationSortText(sort, order)
    );
}
